<template>
  <button @click="list" type="button" class="btn btn-sm btn-secondary mr-1">
    <font-awesome-icon icon="list" />&nbsp;{{ $t('clientInfo') }}
    <b-modal modal-class="modal-fullscreen" content-class="modal-content-2" size="xl" header-class="pb-0" min
      header-bg-variant="white" v-model="showList" hide-footer ok-only no-close-on-backdrop no-enforce-focus>
      <template #modal-title>
        <b-tabs nav-class="nav-item-2" v-model="tabIndex">
          <b-tab>
            <template #title>
              <font-awesome-icon icon="chart-bar" />&nbsp;{{ $t('statistic') }}
            </template>
          </b-tab>
          <b-tab :title-item-class="$store.state.user.role === 'lookup' ? 'd-none' : ''">
            <template #title>
              <font-awesome-icon icon="list" />&nbsp;Email sender
            </template>
          </b-tab>
          <b-tab>
            <template #title>
              <font-awesome-icon icon="users" />&nbsp;{{ $t('clientUser') }}
            </template>
          </b-tab>
          <b-tab :title-item-class="$store.state.user.role === 'lookup' ? 'd-none' : ''">
            <template #title>
              <font-awesome-icon icon="phone" />&nbsp;{{ $t('phoneNumber') }}
            </template>
          </b-tab>
          <b-tab :title-item-class="$store.state.user.role === 'lookup' ? 'd-none' : ''">
            <template #title>
              <font-awesome-icon icon="cog" />&nbsp;{{ $t('phoneSetting') }}
            </template>
          </b-tab>
          <b-tab>
            <template #title>
              <font-awesome-icon icon="file" />&nbsp;{{ $t('profile') }}
            </template>
          </b-tab>
          <b-tab>
            <template #title>
              <font-awesome-icon icon="history" />&nbsp;{{ $t('activity') }}
            </template>
          </b-tab>
          <b-tab :title-item-class="tabIndex !== 7 ? 'd-none' : ''">
            <template #title>
              <font-awesome-icon icon="dollar-sign" />&nbsp;{{ $t('callFeeOverview') }}
            </template>
          </b-tab>
          <b-tab :title-item-class="tabIndex !== 8 ? 'd-none' : ''">
            <template #title>
              <font-awesome-icon icon="dollar-sign" />&nbsp;{{ $t('financeReport') }}
            </template>
          </b-tab>
          <b-tab :title-item-class="tabIndex !== 9 ? 'd-none' : ''">
            <template #title>
              <font-awesome-icon icon="list" />&nbsp;{{ $t('productList') }}
            </template>
          </b-tab>
          <b-tab :title-item-class="tabIndex !== 10 ? 'd-none' : ''">
            <template #title>
              <font-awesome-icon icon="list" />&nbsp;{{ $t('orderList') }}
            </template>
          </b-tab>
          <b-tab :title-item-class="tabIndex !== 11 ? 'd-none' : ''">
            <template #title>
              <font-awesome-icon icon="history" />&nbsp;{{ $t('salesOpportunityHistory') }}
            </template>
          </b-tab>
          <b-tab :title-item-class="tabIndex !== 12 ? 'd-none' : ''">
            <template #title>
              <font-awesome-icon icon="history" />&nbsp;{{ $t('orderHistory') }}
            </template>
          </b-tab>
          <b-tab :title-item-class="tabIndex !== 13 ? 'd-none' : ''">
            <template #title>
              <font-awesome-icon icon="link" />&nbsp;{{ $t('socialNetworkAccounts') }}
            </template>
          </b-tab>
          <b-tab :title-item-class="tabIndex !== 14 ? 'd-none' : ''">
            <template #title>
              <font-awesome-icon icon="list" />&nbsp;{{ $t('contacts') }}
            </template>
          </b-tab>
          <b-tab :title-item-class="tabIndex !== 15 ? 'd-none' : ''">
            <template #title>
              <font-awesome-icon icon="credit-card" />&nbsp;{{ $t('planOrder') }}
            </template>
          </b-tab>
          <b-tab :title-item-class="tabIndex !== 16 ? 'd-none' : ''">
            <template #title>
              <font-awesome-icon icon="credit-card" />&nbsp;{{ $t('clientPackage') }}
            </template>
          </b-tab>
          <b-tab :title-item-class="tabIndex !== 17 ? 'd-none' : ''">
            <template #title>
              <font-awesome-icon icon="sms" />&nbsp;BrandName SMS
            </template>
          </b-tab>
          <b-tab :title-item-class="tabIndex !== 18 ? 'd-none' : ''">
            <template #title>
              <font-awesome-icon icon="cubes" />&nbsp;BrandName Viber
            </template>
          </b-tab>
          <b-tab :title-item-class="tabIndex !== 19 ? 'd-none' : ''">
            <template #title>
              <font-awesome-icon icon="comments" />&nbsp;BrandName Viber
            </template>
          </b-tab>
          <b-tab :title-item-class="tabIndex !== 20 ? 'd-none' : ''">
            <template #title>
              <font-awesome-icon icon="history" />&nbsp;{{ $t('callHistory') }}
            </template>
          </b-tab>
          <b-tab :title-item-class="tabIndex !== 21 ? 'd-none' : ''">
            <template #title>
              <font-awesome-icon icon="history" />&nbsp;{{ $t('zaloOAHistory') }}
            </template>
          </b-tab>
          <b-tab :title-item-class="tabIndex !== 22 ? 'd-none' : ''">
            <template #title>
              <font-awesome-icon icon="history" />&nbsp;{{ $t('facebookHistory') }}
            </template>
          </b-tab>
          <b-tab :title-item-class="tabIndex !== 23 ? 'd-none' : ''">
            <template #title>
              <font-awesome-icon icon="history" />&nbsp;{{ $t('chatbotHistory') }}
            </template>
          </b-tab>
          <b-tab :title-item-class="tabIndex !== 24 ? 'd-none' : ''">
            <template #title>
              <font-awesome-icon icon="history" />&nbsp;{{ $t('chatSessionHistory') }}
            </template>
          </b-tab>
          <b-tab :title-item-class="tabIndex !== 25 ? 'd-none' : ''">
            <template #title>
              <font-awesome-icon icon="credit-card" />&nbsp;{{ $t('clientChatbot') }}
            </template>
          </b-tab>
          <b-tab :title-item-class="tabIndex !== 26 ? 'd-none' : ''">
            <template #title>
              <font-awesome-icon icon="bullhorn" />&nbsp;{{ $t('promotion') }}
            </template>
          </b-tab>
          <template v-slot:tabs-end>
            <b-dropdown boundary="scrollParents" :text="$t('more')" variant="transparent" class="custom-dropdown">
              <template v-if="$store.state.user.role !== 'lookup'">
                <b-dropdown-item @click="tabIndex = 26">
                  {{ $t('promotion') }}
                </b-dropdown-item>
                <b-dropdown-item @click="tabIndex = 7">
                  {{ $t('callFeeOverview') }}
                </b-dropdown-item>
                <b-dropdown-item @click="tabIndex = 8">
                  {{ $t('financeReport') }}
                </b-dropdown-item>
                <b-dropdown-item @click="tabIndex = 9">
                  {{ $t('productList') }}
                </b-dropdown-item>
                <b-dropdown-item @click="tabIndex = 10">
                  {{ $t('orderList') }}
                </b-dropdown-item>
                <b-dropdown-item @click="tabIndex = 11">
                  {{ $t('salesOpportunityHistory') }}
                </b-dropdown-item>
                <b-dropdown-item @click="tabIndex = 12">
                  {{ $t('orderHistory') }}
                </b-dropdown-item>
              </template>
              <b-dropdown-item @click="tabIndex = 20">
                {{ $t('callHistory') }}
              </b-dropdown-item>
              <template v-if="$store.state.user.role !== 'lookup'">
                <b-dropdown-item @click="tabIndex = 13">
                  {{ $t('socialNetworkAccounts') }}
                </b-dropdown-item>
                <b-dropdown-item @click="tabIndex = 14">
                  {{ $t('contacts') }}
                </b-dropdown-item>
                <b-dropdown-item @click="tabIndex = 15">
                  {{ $t('planOrder') }}
                </b-dropdown-item>
                <b-dropdown-item @click="tabIndex = 16">
                  {{ $t('clientPackage') }}
                </b-dropdown-item>
                <b-dropdown-item @click="tabIndex = 25">
                  {{ $t('clientChatbot') }}
                </b-dropdown-item>
                <b-dropdown-item @click="tabIndex = 17">
                  BrandName SMS
                </b-dropdown-item>
                <b-dropdown-item @click="tabIndex = 18">
                  BrandName Viber
                </b-dropdown-item>
                <b-dropdown-item @click="tabIndex = 19">
                  ZNS Template
                </b-dropdown-item>
                <b-dropdown-item @click="tabIndex = 21">
                  {{ $t("zaloOAHistory") }}
                </b-dropdown-item>
                <b-dropdown-item @click="tabIndex = 22">
                  {{ $t("facebookHistory") }}
                </b-dropdown-item>
                <b-dropdown-item @click="tabIndex = 23">
                  {{ $t("chatbotHistory") }}
                </b-dropdown-item>
                <b-dropdown-item @click="tabIndex = 24">
                  {{ $t("chatSessionHistory") }}
                </b-dropdown-item>
              </template>
            </b-dropdown>
          </template>
        </b-tabs>
      </template>
      <client-care v-if="tabIndex === 0" :client="client"></client-care>
      <email-sender-list v-if="tabIndex === 1" :client="client"></email-sender-list>
      <client-user v-if="tabIndex === 2" :client="client"></client-user>
      <number-list v-if="tabIndex === 3" :client="client"></number-list>
      <phone-setting v-if="tabIndex === 4" :client="client"></phone-setting>
      <k-y-c-list v-if="tabIndex === 5" :client="client"></k-y-c-list>
      <client-log v-if="tabIndex === 6" :client="client"></client-log>
      <call-fee-overview-list v-if="tabIndex === 7" :client="client"></call-fee-overview-list>
      <finance-list v-if="tabIndex === 8" :client="client"></finance-list>
      <product-list v-if="tabIndex === 9" :client="client"></product-list>
      <order-list v-if="tabIndex === 10" :client="client"></order-list>
      <opportunity-log v-if="tabIndex === 11" :client="client"></opportunity-log>
      <order-log v-if="tabIndex === 12" :client="client"></order-log>
      <social-network-account-list v-if="tabIndex === 13" :client="client"></social-network-account-list>
      <client-contact v-if="tabIndex === 14" :client="client"></client-contact>
      <plan-order-list v-if="tabIndex === 15" :client="client"></plan-order-list>
      <client-package-list v-if="tabIndex === 16" :client="client"></client-package-list>
      <s-m-s-brand-name-list v-if="tabIndex === 17" :client="client"></s-m-s-brand-name-list>
      <viber-brand-name-list v-if="tabIndex === 18" :client="client"></viber-brand-name-list>
      <z-n-s-template-list v-if="tabIndex === 19" :client="client"></z-n-s-template-list>
      <call-list v-if="tabIndex === 20" :client="client"></call-list>
      <zalo-oa-history v-if="tabIndex === 21" :clientId="client.id"></zalo-oa-history>
      <facebook-history v-if="tabIndex === 22" :clientId="client.id"></facebook-history>
      <chatbot-history v-if="tabIndex === 23" :clientId="client.id"></chatbot-history>
      <chat-session-history v-if="tabIndex === 24" :clientId="client.id"></chat-session-history>
      <client-chatbot-list v-if="tabIndex === 25" :client="client"></client-chatbot-list>
      <promotion-list v-if="tabIndex === 26" :client="client"></promotion-list>
    </b-modal>
  </button>
</template>
<script>
import KYCList from "./client-kyc/KYCList";
import ClientLog from "./ClientLog";
import NumberList from "../phone/NumberList";
import ClientUser from "./ClientUser";
import EmailSenderList from "../email/EmailSenderList";
import PhoneSetting from "@/views/client/phone-setting/Setting";
import ClientCare from "@/views/client/ClientCareReport";
import PlanOrderList from "@/views/finance/plan-order/PlanOrderList";
import ClientPackageList from "@/views/finance/client-package/ClientPackageList";
import CallFeeOverviewList from "@/views/report/CallFeeOverviewList";
import FinanceList from "@/views/report/FinanceList";
import ClientContact from "@/views/client/ClientContact.vue";
import ProductList from "@/views/client/client-info/ProductList";
import OrderList from "@/views/client/client-info/OrderList";
import OpportunityLog from "@/views/client/client-info/OpportunityLog.vue";
import OrderLog from "@/views/client/client-info/OrderLog.vue";
import SocialNetworkAccountList from "@/views/client/client-info/SocialNetworkAccountList.vue";
import SMSBrandNameList from "@/views/sms/SMSBrandNameList.vue";
import ViberBrandNameList from "@/views/viber/ViberBrandNameList.vue";
import ZNSTemplateList from "@/views/zns/ZNSTemplateList.vue";
import CallList from "@/views/client/CallList.vue";
import ZaloOaHistory from "@/views/zalo-oa/History.vue";
import FacebookHistory from "@/views/facebook/History.vue";
import ChatbotHistory from "@/views/chatbot/History.vue";
import ChatSessionHistory from "@/views/chat-session/History.vue";
import ClientChatbotList from "@/views/finance/client-chatbot/ClientChatbotList.vue";
import PromotionList from "@/views/client/PromotionList.vue";

export default {
  props: {
    client: Object
  },
  components: {
    ClientChatbotList,
    OrderList,
    ProductList,
    ClientContact,
    FinanceList,
    CallFeeOverviewList,
    ClientPackageList,
    ClientCare, KYCList, ClientLog, NumberList,
    ClientUser, EmailSenderList, PhoneSetting,
    PlanOrderList,
    OpportunityLog,
    OrderLog,
    SocialNetworkAccountList,
    SMSBrandNameList,
    ViberBrandNameList,
    ZNSTemplateList,
    CallList,
    ZaloOaHistory,
    FacebookHistory,
    ChatbotHistory,
    ChatSessionHistory,
    PromotionList
  },
  data() {
    return {
      showList: false,
      tabIndex: 2
    }
  },
  methods: {
    list() {
      this.showList = true;
    }
  },
  i18n: {
    messages: {
      en: {
        clientInfo: "Client info",
        profile: "Profile",
        customerProfile: 'Customer profile',
        clientUser: "Users",
        activity: "Activity",
        phoneSetting: "Phone setting",
        statistic: "Statistic",
        planOrder: "Plan order",
        callFeeOverview: "Call fee overview",
        financeReport: "Finance report",
        commonInfo: 'General info',
        contacts: "Contact",
        productList: "Product list",
        orderList: "Order list",
        salesOpportunityHistory: "Sales opportunity history",
        orderHistory: "Order history",
        socialNetworkAccounts: "Social network account",
        callHistory: 'Call history',
        zaloOAHistory: 'Zalo OA history',
        facebookHistory: 'Facebook history',
        chatbotHistory: 'Chatbot history',
        chatSessionHistory: 'Chat session history',
        clientChatbot: 'AI agent order',
        promotion: 'Promotion',
      },
      vi: {
        clientInfo: "Thông tin khách hàng",
        customerProfile: 'Hồ sơ khách hàng',
        profile: "Hồ sơ",
        clientUser: "Người dùng",
        activity: "Hoạt động",
        phoneSetting: "Cài đặt điện thoại",
        statistic: "Thống kê",
        planOrder: "Đơn hàng gói dịch vụ",
        callFeeOverview: "Cước gọi tổng quan",
        financeReport: "Báo cáo dịch vụ gia tăng",
        commonInfo: 'Thông tin chung',
        contacts: "Danh sách liên hệ",
        productList: "Danh sách sản phẩm",
        orderList: "Danh sách đơn hàng",
        salesOpportunityHistory: "Lịch sử cơ hội bán hàng",
        orderHistory: "Lịch sử đơn hàng",
        socialNetworkAccounts: "Tài khoản mạng xã hội",
        callHistory: 'Lịch sử gọi',
        zaloOAHistory: 'Lịch sử Zalo OA',
        facebookHistory: 'Lịch sử Facebook',
        chatbotHistory: 'Lịch sử chatbot',
        chatSessionHistory: 'Lịch sử phiên chat',
        clientChatbot: 'Đơn hàng nhân viên AI',
        promotion: 'Khuyến mãi',
      }
    }
  },
}
</script>

<style>
.modal-content-2 {
  background-color: #e5e5e5;
}

.nav-item-2 {
  font-weight: normal;
  font-size: medium;
}

.modal-fullscreen .modal-dialog {
  max-width: 98%;
}

.custom-dropdown .dropdown-menu {
  max-height: 500px;
  overflow-y: auto;
}
</style>